export default "__VITE_ASSET__56ee8414__"